module.exports = __webpack_public_path__ + "img/title-anseio.b8b23096.svg";